import { actions } from "./state";

export const changeBundle = (props) => {
	return {
		type: actions.CHANGE_BUNDLE,
		payload: props,
	};
};

export const changeKunjungan = (props) => {
	return {
		type: actions.CHANGE_KUNJUNGAN,
		payload: props,
	};
};

export const changeDetailHeader = (props) => {
	return {
		type: actions.CHANGE_DETAIL_HEADER,
		payload: props,
	};
};

export const changeLoading = (props) => {
	return {
		type: actions.CHANGE_LOADING,
		payload: props,
	};
};
